import React from 'react';
import { connect } from 'react-redux';
import { CSSTransition } from 'react-transition-group';
import { closeApartment, selectView } from './';
import {data as dataResidences} from './dataResidences'; // make sure this path is correct
import ConnectButtonPhotoHotspotSmall from '../../shared/photo-hotspot/ConnectButtonPhotoHotspotSmall';

function ViewResidencesApartment({ residences, closeApartment, selectView }) {
  const { apartment, isApartmentActive } = residences;

const match = apartment.match(/Apartment\s+(\d+)/);
const aptNumber = match ? match[1] : null;
const isSpecialApartment = aptNumber === "7" || aptNumber === "8";

const getHotSpots = () => {
  const btnList = [];
  const hotspots = dataResidences.plansHotSpots[apartment]; // get hotspots for current apartment

  if (hotspots && hotspots.length > 0) {
    hotspots.forEach((hotspot, i) => {
      btnList.push(
        <ConnectButtonPhotoHotspotSmall
          key={i}
          data={hotspot}
          onSelected={() => {}}
        />
      );
    });
  }

  return btnList;
};
  return (
    <CSSTransition
      className="residences--apartment"
      in={isApartmentActive}
      timeout={300}
      classNames="fade"
      unmountOnExit
    >
      <div>
        {/* Apartment background image */}
        <img
          className="shared--img-fill"
          src={`./img/apartments/${apartment}.jpg`}
          width="1920"
          height="1080"
          alt="residences level"
        />

        {isSpecialApartment ? (
          <div className="residences--apartment__dual-btns">

            <img
              className="residences--apartment__view-btn"
              src="./img/apartments/roof-views.png"
              alt={`Apartment ${aptNumber} Rooftop`}
              onClick={() => selectView(`Apartment ${aptNumber} Rooftop VIEW`)}
            />
            <img
              className="residences--apartment__view-btn"
              src="./img/apartments/level-4-views.png"
              alt={`Apartment ${aptNumber} View`}
              onClick={() => selectView(`Apartment ${aptNumber} VIEW`)}
            />

          </div>
        ) : (
          <img
            className="residences--apartment__view-btn"
            src="./img/apartments/view_btn.png"
            alt={`View ${apartment}`}
            onClick={() => selectView(`${apartment} VIEW`)}
          />
        )}

              <div className='residences--apartment-btns'>
                { getHotSpots() }
              </div>


        {/* Close button */}
        <button
          className="residences--apartment__close-btn"
          onClick={closeApartment}
        />
      </div>
    </CSSTransition>
  );
}




const mapStateToProps = (state) => ({
  residences: state.residences,
});

const mapDispatchToProps = (dispatch) => ({
  closeApartment: () => dispatch(closeApartment()),
  selectView: (view) => dispatch(selectView(view)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ViewResidencesApartment);
